import { ReactElement } from 'react';

// Components
import CurrencyField from '../../../../components/CurrencyField';
import TextField from '../../../../components/TextField';
import Translation from '../../../../components/Translation';

// Hooks
import useTranslations from '../../../../hooks/useTranslations';

// Utils
import { PropertyDetailFormInterface } from '../../../../types/Property/PropertyDetailFormInterface';
import { fieldRequired } from '../../../../formValidators/fieldRequired';

export default function PrivateBusinessPropertyForm({
  control,
  errors,
  clearErrors,
  getValues,
  register,
  setValue,
}: PropertyDetailFormInterface ): ReactElement{

  const { getTranslation } = useTranslations();

  const useFormProps = {
    control,
    register,
    setValue,
    errors,
    getValues,
    clearErrors,
  };

  return(
    <>
      <TextField { ...useFormProps }
        name="name"
        label={ <Translation translationKey="property.field.name.label" /> }
        required={ fieldRequired( getTranslation( 'property.field.name.required' )) }
        autoComplete="off"
        className="mb-8"
      />

      <CurrencyField
        errors={ errors }
        label={ <Translation translationKey="form.property.business.field.value.label" /> }
        name="value"
        control={ control }
        className="mb-8"
      />
    </>
  );
}

